import React from 'react'
import NavBarSecondary from '../../components/Nav/NavBarSecondary'
import NavBarSecondaryMobile from '../../components/Nav/NavBarSecondaryMobile'
import MatrixGoldRoutes from './MatrixGoldRoutes'
import { FormattedMessage } from 'react-intl'
import { ConfigContext } from '../../App'
import { Box } from '@mui/material'

const MatrixGold = () => {
  const configContext = React.useContext(ConfigContext)
  return (
    <div data-cy='matrixgold-container'>
      {configContext.isSmallScreen ? (
        <NavBarSecondaryMobile
          storeURL='/store/matrixgold-3/with-rhinoceros'
          logo='https://gemvision.com/Images/MatrixGold/MatrixGold%20Light%20Registered.svg'
          logoWidth={128}
          logoAlt={'MatrixGold'}
          navBarSecondaryTab={[
            { label: <FormattedMessage id='nav.overview' />, url: '/matrixgold' },
            { label: <FormattedMessage id='matrixgold3.tab.3.10' />, url: '/matrixgold/matrixgold-3', new: true },
            { label: <FormattedMessage id='nav.features' />, url: '/matrixgold/features' },
            { label: <FormattedMessage id='nav.gallery' />, url: '/matrixgold/gallery' },
            {
              label: <FormattedMessage id='common.releaseNotes' />,
              url: '/matrixgold/release-notes'
            },
            { label: <FormattedMessage id='nav.membership' />, url: '/matrixgold/membership' },
            {
              label: <FormattedMessage id='nav.systemRequirements' />,
              url: '/matrixgold/systemrequirements'
            }
          ]}
        />
      ) : (
        <NavBarSecondary
          storeURL='/store/matrixgold-3/with-rhinoceros'
          indicatorColor='#b4975a'
          navBarSecondaryTab={[
            {
              label: (
                <Box
                  component='img'
                  sx={{ height: 11 }}
                  alt='MatrixGold'
                  src='https://gemvision.com/Images/MatrixGold/MatrixGold%20Light%20Registered.svg'
                />
              ),
              url: '/matrixgold'
            },
            { label: <FormattedMessage id='matrixgold3.tab.3.10' />, url: '/matrixgold/matrixgold-3', new: true },
            { label: <FormattedMessage id='nav.features' />, url: '/matrixgold/features' },
            { label: <FormattedMessage id='nav.gallery' />, url: '/matrixgold/gallery' },
            {
              label: <FormattedMessage id='common.releaseNotes' />,
              url: '/matrixgold/release-notes'
            },
            { label: <FormattedMessage id='nav.membership' />, url: '/matrixgold/membership' },
            {
              label: <FormattedMessage id='nav.systemRequirements' />,
              url: '/matrixgold/systemrequirements'
            }
          ]}
        />
      )}
      <MatrixGoldRoutes />
    </div>
  )
}

export default MatrixGold
